export const placeholderTypes = {
  listing: 'listing',
  listingMap: 'listingMap',
  bookingTotal: 'bookingTotal',
  widgetEdit: 'widgetEdit',
  pdp: 'pdp',
  pdpMobile: 'pdpMobile',
  pdpAddress: 'pdpAddress',
  pdpOffer: 'pdpOffer',
  pdpOfferRedesigned: 'pdpOfferRedesigned',
  pdpOfferMobile: 'pdpOfferMobile',
  pdpOfferMobileRedesigned: 'pdpOfferMobileRedesigned',
  pdpOfferPriceLoading: 'pdpOfferPriceLoading',
  pdpOfferPriceLoadingMobile: 'pdpOfferPriceLoadingMobile',
  home: 'home',
  bdp: 'bdp',
  checkIn: 'checkIn',
  elfsight: 'elfsight',
  elfsightMinified: 'elfsightMinified',
  checkoutRatePlans: 'checkoutRatePlans',
  bookingCard: 'bookingCard',
  bookingCardGrid: 'bookingCardGrid',
  bookingWidget: 'bookingWidget',
  bookingWidgetMobile: 'bookingWidgetMobile',
  bookingWidgetFooter: 'bookingWidgetFooter',
  bookingWidgetFooterMobile: 'bookingWidgetMobileFooter',
  roomDetails: 'roomDetails'
};
